import "./ProfilNavBar.css";
import avatar from '../../Assets/avatar.png';
import React, { useEffect, useState } from "react";
import { FaUserAlt } from "react-icons/fa";
import { AiFillSetting, AiOutlineMenu } from "react-icons/ai";
import { BiLogOutCircle } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { Button, Dropdown, ButtonGroup } from 'react-bootstrap';
import { signOutUser } from '../../Pages/Auth/authServices';
import {  PARAMETRE_NAVIGATION, PROFIL_NAVIGATION } from '../../Routes/NAVIGATION_PATH';
import { getDocument } from "../../Firebase";

function ProfilNavBar() {
  const [currentUser ,setCurrentUser] = useState({})
  const currentUserId = sessionStorage.getItem("user_id");
 useEffect(()=>{
    getDocument('users', currentUserId , setCurrentUser)
 },[])
  const navigate = useNavigate();
  const myphoto = currentUser?.photo !== undefined? currentUser?.photo : avatar;

  return (
    <Dropdown className="dropNAvbar" as={ButtonGroup}>
      <Dropdown.Toggle id="dropdown-custom-1">
        {
          currentUser.user_type === "etudiant" ? <AiOutlineMenu className="btnMenu pb-2" /> :
        <img src={myphoto} alt='zlogo' className='imgNavBar' />
        }
      </Dropdown.Toggle>
      <Dropdown.Menu className="super-colors ">
        <h6 className="text-center">Setting</h6>
        <Dropdown.Item eventKey="1">
          <Link to={PROFIL_NAVIGATION}> <FaUserAlt /> Profile</Link>
        </Dropdown.Item>
        <Dropdown.Item eventKey="2">
          <Link to={PARAMETRE_NAVIGATION}> <AiFillSetting /> Parameter</Link>
        </Dropdown.Item>
        <Dropdown.Item eventKey="2">
          <Button className="bDprdNb" onClick={() => (signOutUser(navigate))}> <BiLogOutCircle /> Deconnexion</Button>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfilNavBar;
